import { render, staticRenderFns } from "./ProductIconList.vue?vue&type=template&id=23ea74cc&"
import script from "./ProductIconList.vue?vue&type=script&lang=js&"
export * from "./ProductIconList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports